import { CSSTransition } from 'react-transition-group';
import { Center, Spinner } from 'src/components/atoms';
import * as Types from '../../../../types';
import LoginContainer from '../../LoginContainer';

interface Props {
  authenticationType: string | null;
}

export const SSOLoginRedirect = (props: Props) => {
  const description = `Sending you to ${
    props.authenticationType === Types.AuthenticationType.OKTA
      ? 'Okta'
      : props.authenticationType === Types.AuthenticationType.ONE_LOGIN
        ? 'OneLogin'
        : 'SSO'
  } to complete login...`;

  return (
    <LoginContainer
      data-testid="sso-redirect"
      header="Log in"
      description={description}
      includeForm={false}
    >
      <CSSTransition
        in={props.authenticationType !== Types.AuthenticationType.VAULT_LOGIN}
        timeout={1000}
        classNames="login-transitions"
        unmountOnExit
      >
        <Center>
          <Spinner variant="secondary" size="xlarge" />
        </Center>
      </CSSTransition>
    </LoginContainer>
  );
};

export default SSOLoginRedirect;
